import { Component, OnInit, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TableModule } from 'primeng/table';
import { LocalizationService } from '../../core/localization/localization.service';
import { AinPageComponent } from '../../shared/design-system/page.component';
import { AinStateComponent } from '../../shared/design-system/state.component';
import { DynamicFormPublication, OrganizationDynamicApiService } from './organization-dynamic-api.service';

@Component({
  standalone: true,
  selector: 'ain-organization-assigned-forms',
  imports: [AinPageComponent, AinStateComponent, TableModule, RouterLink],
  template: `
    <ain-page [title]="t('organization.workflow.forms.title')" [description]="t('organization.workflow.forms.description')">
      @if (loading()) {
        <ain-state type="loading" [title]="t('common.loading')" />
      } @else {
        <p-table [value]="forms()" [paginator]="true" [rows]="10">
          <ng-template pTemplate="header">
            <tr>
              <th>{{ t('columns.name') }}</th>
              <th>{{ t('columns.status') }}</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr>
              <td>{{ row.slug }}</td>
              <td>{{ row.visibility }}</td>
              <td><a [routerLink]="['/workflow/forms', row.slug]">{{ t('common.open') }}</a></td>
            </tr>
          </ng-template>
        </p-table>
      }
    </ain-page>
  `,
  styles: [`a { color: var(--ain-color-primary); font-weight: 600; }`]
})
export class OrganizationAssignedFormsComponent implements OnInit {
  private readonly api = inject(OrganizationDynamicApiService);
  private readonly localization = inject(LocalizationService);
  readonly forms = signal<DynamicFormPublication[]>([]);
  readonly loading = signal(true);

  ngOnInit(): void {
    this.api.listPublications().subscribe({
      next: items => {
        this.forms.set(items.filter(item => item.isPublished));
        this.loading.set(false);
      },
      error: () => this.loading.set(false)
    });
  }

  t(key: string): string { return this.localization.translate(key); }
}

